export default __webpack_public_path__ + "static/media/Lluvia_moderada.0c0e6ecc.svg";